(function (angular) {
    'use strict';
    angular.module("dentist").controller('detailController', detailController)

    .directive('birthdayPicker', ['$parse', function ($parse) {
        var directive = {
            link: link,
            restrict: 'A',
        };
        return directive;

        function link(scope, elem, attrs, ctrl) {
            $(elem).datepicker({
                format: 'dd.mm.yyyy',
                autoclose: true,
                startDate: moment().subtract(119, 'years').toDate(),
                endDate: moment().subtract(5, 'months').toDate(),
                language: 'de'
            });
        }
    }]);

    function detailController(dentistService, appointmentService, $translate, $state, $window, $filter, $stateParams) {

        //controller initialization
        var ctrl = this;

        $('.ls-modal').on('click', function(e){
            e.preventDefault();
            $('.modal-title').text($(this).text());
            $('.modal-body').attr('style', '');
            $('#myModal').modal('show').find('.modal-body').load($(this).attr('href'));
        });

        $('.ls-modal-inline').on('click', function(e){
            e.preventDefault();
            $('.modal-title').text($(this).text());
            $('.modal-body').attr('style', 'white-space: pre-wrap;');
            $('#myModal').modal('show').find('.modal-body').text($(this).attr('data-text'));
        });

        ctrl.dentistName = localStorage.getItem("dentistName");
        ctrl.practiceName = localStorage.getItem("practiceName");
        ctrl.practiceId = localStorage.getItem("practiceId");
        ctrl.practiceBookingTerms = localStorage.getItem("practiceBookingTerms");
        ctrl.practiceCalendarType = localStorage.getItem("practiceCalendarType");
        ctrl.serviceName = localStorage.getItem("serviceName");
        ctrl.serviceID = localStorage.getItem("serviceID");
//        ctrl.practitionerId = localStorage.getItem("practitionerId");
        ctrl.practitionerId = localStorage.getItem("selectedActualPractitionerId");
        ctrl.selectedDate = moment(localStorage.getItem("selectedDate")).toDate();
        ctrl.selectedTime = localStorage.getItem("selectedTime");
        ctrl.selectedServiceOriginalId = localStorage.getItem("selectedServiceOriginalId");
        ctrl.selectedService = JSON.parse(localStorage.getItem("selectedServiceObject"));
        ctrl.servicePrice = ctrl.selectedService.priceCalculated;
        ctrl.serviceFixedPrice = ctrl.selectedService.fixedPrice;
        ctrl.ecommerceObject = $stateParams.ecommerceObject;
        ctrl.isStandaloneBooking = $stateParams.standalone;
        ctrl.trafficSource = $stateParams.q;
        ctrl.practiceAddress = localStorage.getItem("practiceAddress");

        ctrl.checkTerm = false;
        if (ctrl.dentistName == null || ctrl.serviceName == null || ctrl.selectedDate == null || ctrl.dentistName == '' || ctrl.serviceName == '' || ctrl.selectedDate == '') {
            $state.go("index");
        }

        ctrl.detail = {
            salutation: "",
            firstname: "",
            lastname: "",
            addressStreet: "",
            addressStreetNumber: "",
            addressPostalCode: "",
            addressCity: "",
            email: "",
            confirmEmail: "",
            phone: "",
            selectedDate: buildSelectedDateTime(),
            serviceId: ctrl.selectedServiceOriginalId,
            practitionerId: ctrl.practitionerId,
            type: ctrl.isStandaloneBooking ? "STANDALONE" : "BOOKING",
            source: ctrl.trafficSource
        };

        ctrl.showVoucherErrorMessage = false;
        ctrl.loginSuccess = false;
        ctrl.showsubmit = true;
        ctrl.LoginSubmitted = false;
        ctrl.RegSubmitted = false;
        ctrl.SubmitLoggedinBooking = SubmitLoggedinBooking;
        ctrl.loginDetail = {
            Email: "",
            Password: ""
        };
        ctrl.Login = Login;
        ctrl.Submit = Submit;
        ctrl.showSubmit = showSubmit;
        ctrl.showLogin = showLogin;
        ctrl.changedata = changedata;
        ctrl.applyVoucher = applyVoucher;
        ctrl.cancelVoucher = cancelVoucher;
        ctrl.changePayTime = changePayTime;
        ctrl.changeLanguage = changeLanguage;
        ctrl.isMentorBooking = isMentorBooking;
        ctrl.isBirthdateMandatory = isBirthdateMandatory;

        init();

        function init() {
            if(localStorage.getItem("customerdetail") == "true") {
                ctrl.detail.firstname = localStorage.getItem("detailfirstname") == "undefined" ? "": localStorage.getItem("detailfirstname");
                ctrl.detail.lastname = localStorage.getItem("detaillastname") == "undefined" ? "": localStorage.getItem("detaillastname");
                ctrl.detail.addressStreet = localStorage.getItem("detailaddressStreet") == "undefined" ? "": localStorage.getItem("detailaddressStreet");
                ctrl.detail.addressStreetNumber = localStorage.getItem("detailaddressStreetNumber") == "undefined" ? "": localStorage.getItem("detailaddressStreetNumber");
                ctrl.detail.addressPostalCode = localStorage.getItem("detailaddressPostalCode") == "undefined" ? "": localStorage.getItem("detailaddressPostalCode");
                ctrl.detail.addressCity = localStorage.getItem("detailaddressCity") == "undefined" ? "": localStorage.getItem("detailaddressCity");
                ctrl.detail.email = localStorage.getItem("detailemail") == "undefined" ? "": localStorage.getItem("detailemail");
                ctrl.detail.confirmEmail = localStorage.getItem("detailconfirmEmail") == "undefined" ? "": localStorage.getItem("detailconfirmEmail");
                ctrl.detail.phone = localStorage.getItem("detailphone") == "undefined" ? "": localStorage.getItem("detailphone");
                ctrl.detail.salutation = localStorage.getItem("detailsalutation") == "undefined" ? "": localStorage.getItem("detailsalutation");
                ctrl.detail.birthdate = localStorage.getItem("detailbirthdate") == "undefined" ? "": localStorage.getItem("detailbirthdate");
            }

            ctrl.showVoucherFields = false;

            if (!ctrl.serviceFixedPrice || ctrl.serviceFixedPrice == 'null' || ctrl.selectedService.fixedPriceReduced || ctrl.isStandaloneBooking) {
                ctrl.payNow = false;
            } else {
                ctrl.payNow = true;
            }

            if (ctrl.selectedService.fixedPriceReduced && !ctrl.isStandaloneBooking) {
                ctrl.voucherDeductionDescription = ctrl.selectedService.reductionCoupon.description;

                calculateVoucherFields(ctrl.selectedService.reductionCoupon);
            }
        }

        function isMentorBooking() {
        	return ($stateParams.practiceId == 29852);
        }

        function isBirthdateMandatory() {
        	return (ctrl.practiceCalendarType == 'ZAWIN') ||
        	    (ctrl.practiceCalendarType == 'ERGODENT') ||
        	    (ctrl.practiceId == 202228); // practice Art D’Luxe wants the date of birth
        }

        function changeLanguage(langKey) {
            $translate.use(langKey);
            localStorage.setItem("lang", langKey);
        }

        function changePayTime() {
            if (ctrl.payNow)
                ctrl.payNow = false;
            else
                ctrl.payNow = true;
        }

        function buildSelectedDateTime() {
            var hourAndMinute = ctrl.selectedTime.split(':');
            var selectedDateTime = moment(ctrl.selectedDate);
            selectedDateTime.hours(hourAndMinute[0]);
            selectedDateTime.minutes(hourAndMinute[1]);
            selectedDateTime.seconds(0);
            return selectedDateTime;
        }

        function showSubmit() {
                ctrl.showsubmit = false;
                $('#register-form-link').addClass('active');
                $("#login-form-link").removeClass("active");
        }

        function changedata() {
            var language = localStorage.getItem("lang");
            //localStorage.clear();
            //window.location = "index.html";
            //window.history.back();

            localStorage.setItem("customerdetail", "true");
            localStorage.setItem("detailfirstname", ctrl.detail.firstname);
            localStorage.setItem("detaillastname", ctrl.detail.lastname);
            localStorage.setItem("detailaddressStreet", ctrl.detail.addressStreet);
            localStorage.setItem("detailaddressStreetNumber", ctrl.detail.addressStreetNumber);
            localStorage.setItem("detailaddressPostalCode", ctrl.detail.addressPostalCode);
            localStorage.setItem("detailaddressCity", ctrl.detail.addressCity);
            localStorage.setItem("detailemail", ctrl.detail.email);
            localStorage.setItem("detailconfirmEmail", ctrl.detail.confirmEmail);
            localStorage.setItem("detailphone", ctrl.detail.phone);
            localStorage.setItem("detailsalutation", ctrl.detail.salutation);
            localStorage.setItem("detailbirthdate", ctrl.detail.birthdate);

            localStorage.setItem("lang", language);
            localStorage.setItem("history", "true");

            $state.go('home', {practiceId: ctrl.practiceId});
        }

        function showLogin() {
            ctrl.showsubmit = true;
            $('#login-form-link').addClass('active');
            $("#register-form-link").removeClass("active");
        }

        function showNotification(_message, _type) {
            switch (_type) {
                case 'success':
                    toastr.success(_message);
                    break;
                case 'error':
                    toastr.error(_message);
                    break;
                case 'warning':
                    toastr.warning(_message);
                    break;
            }
        }

        function applyVoucher() {
            if (!ctrl.detail.couponCode || ctrl.detail.couponCode == '') {
                resetVoucher();
                return;
            }

            dentistService.getCoupon(ctrl.detail.couponCode).then(function (res) {
                var result = res.data;

                var coupon = result;

                if (ctrl.detail.couponCode == coupon.code) {
                    ctrl.voucherDeductionDescription = "Ermässigung";
                    ctrl.showVoucherDeduction = true;
                    ctrl.showVoucherErrorMessage = false;

                    calculateVoucherFields(coupon);
                } else {
                    resetVoucher();
                }

            }, function (error) {
                resetVoucher();
            });
        }

        function calculateVoucherFields(coupon) {
            var MINIMAL_CURRENCY_UNIT = 0.05;
            var oldPrice = Number(ctrl.serviceFixedPrice);
            var newPrice;

            if (coupon.isPercentage) {
                var discount = (oldPrice * coupon.value) / 100;
                var newPriceUnrounded = oldPrice - discount;

                newPrice = Math.round(newPriceUnrounded / MINIMAL_CURRENCY_UNIT) * MINIMAL_CURRENCY_UNIT;
                ctrl.voucherDeduction = '- ' + coupon.value + ' %';
            } else {
                newPrice = oldPrice - coupon.value;
                ctrl.voucherDeduction = '- ' + $filter('currency')(coupon.value);
            }

            ctrl.resultingPrice = $filter('currency')(newPrice);
        }

        function resetVoucher() {
            ctrl.showVoucherDeduction = false;
            ctrl.showVoucherErrorMessage = true;
            ctrl.voucherDeduction = '';
            ctrl.resultingPrice = '';
        }

        function cancelVoucher() {
            ctrl.showVoucherFields = false;
            ctrl.showVoucherDeduction = false;
            ctrl.showVoucherErrorMessage = false;
            ctrl.voucherDeduction = '';
            ctrl.resultingPrice = '';
        }

        function Login(LoginForm) {
            ctrl.LoginSubmitted = true;
            if (LoginForm.$valid) {
                uiBlock();
                dentistService.login(ctrl.loginDetail).then(function (res) {
                    uiUnBlock();
                    var result = res.data;
                    if (result.IsSuccess) {
                        ctrl.loginSuccess = true;
                        ctrl.showsubmit = true;
                        ctrl.detail.salutation = result.data.salutation;
                        ctrl.detail.firstName = result.data.Name;
                        ctrl.detail.addressStreet = result.data.addressStreet;
                        ctrl.detail.addressStreetNumber = result.data.addressStreetNumber;
                        ctrl.detail.addressPostalCode = result.data.addressPostalCode;
                        ctrl.detail.addressCity = result.data.addressCity;
                        ctrl.detail.Email = result.data.Email;
                        ctrl.detail.confirmEmail = result.data.Email;
                        ctrl.detail.Phone = result.data.Phone;
                        // window.location("done.html");
                        ctrl.showMessage = result.data.Name;
                        ctrl.showSecondMessage = 'If you want, you can change your data here:';
                        $('#login-form-link').addClass('active');
                        $('#register-form-link').removeClass('active');
                    }
                    else {
                        var lang = localStorage.getItem("lang");
                        if (lang == "de")
                            showNotification("Invalid Username or Password!", "error");
                        else
                            showNotification(" Ungültiger Benutzername oder Passwort!", "error");

                        //alert("Invalid Username or Password");     Ungültiger Benutzername oder Passwort
                    }

                }, function (error) {

                });
            }
        }

        //PURCHASE when clicked on agreement checkbox in form
        function purchaseProduct(dataLayer, ref) {
            var time = ctrl.detail.selectedDate;

            var variant = "";

            if(time.isBefore(moment().add(1, 'days'))) {
                variant = "24h";
            } else if(time.isBefore(moment().add(2, 'days'))) {
                variant = "24h-48h";
            } else if(time.isBefore(moment().add(7, 'days'))) {
                variant = "2d-1week";
            } else if(time.isBefore(moment().add(14, 'days'))) {
                variant = "1week-2weeks";
            } else if(time.isBefore(moment().add(1, 'months'))) {
                variant = "2weeks-1month";
            } else if(time.isBefore(moment().add(2, 'months'))) {
                variant = "1month-2months";
            } else if(time.isBefore(moment().add(6, 'months'))) {
                variant = "2months-6months";
            } else if(time.isBefore(moment().add(12, 'months'))) {
                variant = "1year";
            } else {
                variant = "over1year";
            }

            var data = {
				  'ecommerce': {
				    'purchase': {
				      'actionField': {
				        'id': String(ref),
				        'affiliation': (ctrl.isStandaloneBooking ? "standalone" : ("c" === ctrl.trafficSource ? "comparis" : "platform")),
				        'list': ctrl.ecommerceObject != null && ctrl.ecommerceObject.ecommerce.click.actionField.list != null ? ctrl.ecommerceObject.ecommerce.click.actionField.list : null,
            			'step': '2',
            			'revenue': '1'
				      },
				      'products': [{ //  adding a product to a shopping cart.
				        'name': String(ctrl.selectedService.type), //treatment name
				        'brand': String(ctrl.practiceName), //practice Name
				        'coupon': ctrl.ecommerceObject != null && ctrl.ecommerceObject.ecommerce.click.products[0].coupon != null ? ctrl.ecommerceObject.ecommerce.click.products[0].coupon : null, // FIXME replace with actual coupon from ctrl.selectedService
				        'position': ctrl.ecommerceObject != null && ctrl.ecommerceObject.ecommerce.click.products[0].position != null ? ctrl.ecommerceObject.ecommerce.click.products[0].position : null,
				        'variant': String(variant),
				        'quantity': '1'
				       }]
				    }
				  }
            };

            if (ctrl.selectedService.fixedPrice) {
                data.ecommerce.purchase.products[0].price = Number(ctrl.selectedService.fixedPrice);
            }

            dataLayer.push(data);
        }

        function Submit(RegisterForm) {
            ctrl.RegSubmitted = true;

            localStorage.setItem("servicePrice", ctrl.servicePrice);
            localStorage.setItem("voucherDeduction", ctrl.voucherDeduction);
            localStorage.setItem("resultingPrice", ctrl.resultingPrice);
            localStorage.setItem("voucherDescription", ctrl.voucherDeductionDescription);
            localStorage.setItem("practiceAddress", ctrl.practiceAddress);

            //var response = grecaptcha.getResponse();
            var response = {
                length: 1
            };
            if (response.length == 0 ) {
                var lang = localStorage.getItem("lang");
                if (lang == "de")
                    showNotification("Auch selbst bestätigen!", "error");
                else
                    showNotification("Validate Yourself also!", "error");
            }
            else {
                if (RegisterForm.$valid) {

                    if (ctrl.detail.birthdate) {
                        // TODO [dom] it is technically possible, to input a date out of the valid range (the bootstrap-datepicker does not correctly erase wrong input).
                        // TODO [dom] In this case, set a valid date here (or fix the validation).
                        ctrl.detail.dateOfBirth = moment.utc(ctrl.detail.birthdate, "DD.MM.YYYY").toDate();
                    }

                    uiBlock();
                    dentistService.insertBookingInformation(ctrl.detail).then(function (res) {
                        uiUnBlock();

                        var result = res.data;

                        var gtmDataLayer = window.dataLayer || [];

                        purchaseProduct(gtmDataLayer, result.reference);

                        gtmDataLayer.push({
                            'event' : (ctrl.isStandaloneBooking ? 'bookingStandaloneSuccess' : 'bookingSuccess')
                        });

                        setTransferState(result);

                        if (result.bookingError) {
                            $state.go("error");
                        } else {
                            $state.go("done");
                        }

                    }, function (error) {
                      // TODO [dom] implement error handling
                      // uiUnBlock();
                    });
                }
            }
        }

        function setTransferState(result) {
            localStorage.setItem("bookingReference", result.reference);
            localStorage.setItem("practiceId", ctrl.practiceId);
        }

        function SubmitLoggedinBooking() {
                dentistService.insertBookingInformation(ctrl.detail).then(function (res) {
                    var result = res.data;
                    if (result.IsSuccess) {
                        //showNotification("Your booking has been made", "success");
                    	localStorage.setItem("bookingReference",result.reference);
                        $state.go("done");
                    } else {

                    }
                }, function (error) {

                });
        }

    }

    detailController.$inject = ['dentistService', 'appointmentService', '$translate', '$state', '$window', '$filter', '$stateParams'];

})(window.angular);
